import React, { useState, useEffect } from 'react';
import PageLoader from '../components/PageLoader';
import FeedbackModal from '../components/FeedbackModal';
import { api } from '../App';
import '../styles/AdminProductenPage.css';
import '../styles/AdminLeveringsdatumsPage.css';

function AdminLeveringsdatumsPage({ onBack, onLogout }) {
  const [datums, setDatums] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [newDatum, setNewDatum] = useState('');
  const [editingDatum, setEditingDatum] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);

  useEffect(() => {
    loadDatums();
  }, []);

  const loadDatums = async () => {
    try {
      setError('');
      const response = await api.get('/index.php?action=admindatumbeheer');
      setDatums(response.data);
      setLoading(false);
    } catch (err) {
      setError(err.response?.data?.message || 'Fout bij laden van leveringsdatums');
      setLoading(false);
    }
  };

  const handleAddDatum = async (e) => {
    e.preventDefault();
    if (!newDatum) return;

    try {
      setError('');
      await api.post('/index.php?action=admindatum', { datum: newDatum });
      setNewDatum('');
      setSuccess('Leveringsdatum toegevoegd');
      loadDatums();
    } catch (err) {
      setError(err.response?.data?.message || 'Fout bij toevoegen');
    }
  };

  const handleSaveDatum = async (e) => {
    e.preventDefault();
    if (!editingDatum?.datum) return;

    try {
      setError('');
      await api.put('/index.php?action=admindatum', {
        id: editingDatum.ID,
        datum: editingDatum.datum
      });
      setEditingDatum(null);
      setSuccess('Leveringsdatum bijgewerkt');
      loadDatums();
    } catch (err) {
      setError(err.response?.data?.message || 'Fout bij opslaan');
    }
  };

  const handleDeleteDatum = async (id) => {
    try {
      setError('');
      await api.delete(`/index.php?action=admindatum&id=${id}`);
      setConfirmDelete(null);
      setSuccess('Leveringsdatum verwijderd');
      loadDatums();
    } catch (err) {
      setError(err.response?.data?.message || 'Fout bij verwijderen');
      setConfirmDelete(null);
    }
  };

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="admin-producten-container admin-datums-container">
      {confirmDelete && (
        <FeedbackModal
          title="Leveringsdatum verwijderen?"
          message={confirmDelete.message}
          onConfirm={() => handleDeleteDatum(confirmDelete.id)}
          onCancel={() => setConfirmDelete(null)}
          confirmLabel="Verwijderen"
          cancelLabel="Annuleren"
        />
      )}

      {success && (
        <FeedbackModal
          title="Gelukt"
          message={success}
          onConfirm={() => setSuccess('')}
          confirmLabel="Ok"
        />
      )}

      <header className="admin-header">
        <button type="button" onClick={onBack} className="back-button">← Terug</button>
        <h1>Leveringsdatums</h1>
        <button type="button" onClick={onLogout} className="logout-button">Uitloggen</button>
      </header>

      <main className="admin-main">
        <div className="admin-content admin-datums-content">
          {error && <div className="error-message">{error}</div>}

          <p className="info-text admin-datums-intro">
            Beheer de datums waarop speltakken kunnen bestellen. Datums met bestellingen
            kunnen niet worden verwijderd.
          </p>

          <form className="add-datum-form" onSubmit={handleAddDatum}>
            <h3>Nieuwe leveringsdatum</h3>
            <div className="add-datum-fields">
              <input
                type="date"
                value={newDatum}
                onChange={(e) => setNewDatum(e.target.value)}
                required
                className="datum-input"
              />
              <button type="submit" className="primary-btn">Toevoegen</button>
            </div>
          </form>

          {datums.length === 0 ? (
            <p className="info-text">Nog geen leveringsdatums ingesteld.</p>
          ) : (
            <table className="producten-table datums-table">
              <thead>
                <tr>
                  <th>Leveringsdatum</th>
                  <th>Bestellingen</th>
                  <th>Status</th>
                  <th>Acties</th>
                </tr>
              </thead>
              <tbody>
                {datums.map((row) =>
                  editingDatum?.ID === row.ID ? (
                    <tr key={row.ID} className="editing-row">
                      <td colSpan={4}>
                        <form className="inline-edit-form datum-edit-form" onSubmit={handleSaveDatum}>
                          <input
                            type="date"
                            value={editingDatum.datum}
                            onChange={(e) =>
                              setEditingDatum({ ...editingDatum, datum: e.target.value })
                            }
                            required
                            className="datum-input"
                          />
                          <button type="submit" className="primary-btn">Opslaan</button>
                          <button
                            type="button"
                            className="secondary-btn"
                            onClick={() => setEditingDatum(null)}
                          >
                            Annuleren
                          </button>
                        </form>
                      </td>
                    </tr>
                  ) : (
                    <tr key={row.ID}>
                      <td>{row.formatted}</td>
                      <td>{row.aantal_bestellingen}</td>
                      <td>
                        <span
                          className={`datum-status ${
                            row.is_verleden ? 'datum-status-past' : 'datum-status-future'
                          }`}
                        >
                          {row.is_verleden ? 'Verleden' : 'Toekomst'}
                        </span>
                      </td>
                      <td className="actions-cell">
                        <button
                          type="button"
                          className="small-btn"
                          onClick={() =>
                            setEditingDatum({ ID: row.ID, datum: row.datum })
                          }
                        >
                          Bewerken
                        </button>
                        <button
                          type="button"
                          className="small-btn danger-btn"
                          disabled={row.aantal_bestellingen > 0}
                          title={
                            row.aantal_bestellingen > 0
                              ? 'Niet verwijderbaar: er zijn bestellingen gekoppeld'
                              : 'Verwijderen'
                          }
                          onClick={() =>
                            setConfirmDelete({
                              id: row.ID,
                              message: `Weet je zeker dat je ${row.formatted} wilt verwijderen?`
                            })
                          }
                        >
                          Verwijderen
                        </button>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          )}
        </div>
      </main>
    </div>
  );
}

export default AdminLeveringsdatumsPage;
